import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar"; // Adjust the import path if needed

// Import team images
import lohitImg from "../assets/team/lohit.jpg";
import kunalImg from "../assets/team/kunal.jpg";
import ishaImg from "../assets/team/isha.jpg";
import rasmiranjanImg from "../assets/team/rasmiranjan.jpg";
import mehtabImg from "../assets/team/mehtab.jpg";
import adyashaImg from "../assets/team/adyasha.jpg";
import userImg from "../assets/team/user.png";
import samudraImg from "../assets/team/samudra.png";
import dhriti from "../assets/team/dhriti.jpg";
import prateek from "../assets/team/prateek.jpg";
import subhankar from "../assets/team/subhankar.jpg";
import varun from "../assets/team/varun.jpg";
import akash from "../assets/team/akash.jpg";

const TeamPage = () => {
  

  return (
    <>
      <Helmet>
        {/* Font Awesome for social icons */}
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.0/css/all.min.css"
        />
      </Helmet>

      {/* Your existing Navbar */}
      <Navbar />

      <div>
        <style>{`
          :root {
            --gradient-primary: linear-gradient(135deg, #2563eb, #4f46e5);
            --gradient-secondary: linear-gradient(135deg, #1e40af, #3730a3);
            --accent-gradient: linear-gradient(135deg, #3b82f6, #8b5cf6);
            --text-primary: #f8fafc;
            --text-secondary: #94a3b8;
            --background-dark: #0f172a;
            --background-darker: #020617;
            --card-bg: rgba(30, 41, 59, 0.8);
            --card-hover-bg: rgba(51, 65, 85, 0.9);
            --transition-slow: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
            --transition-medium: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            --transition-fast: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          }

          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: Exo, sans-serif;
          }
          @font-face {
            font-family: Exo;
            src: url(./fonts/Exo2.0-Medium.otf);
          }

          .main {
            width: 100%;
            min-height: 100vh;
            padding-top: 80px;
            padding-bottom: 40px;
            background: var(--background-dark);
            background-image: 
              radial-gradient(circle at 20% 30%, rgba(59,130,246,0.15) 0%, transparent 25%),
              radial-gradient(circle at 80% 70%, rgba(139,92,246,0.15) 0%, transparent 25%),
              radial-gradient(circle at 50% 50%, rgba(14,165,233,0.05) 0%, transparent 50%);
            overflow: hidden;
            z-index: 1;
          }

          .category-section {
            margin: 40px auto;
            max-width: 1400px;
            width: 90%;
          }

          .category-section h2 {
            font-size: 2rem;
            margin-bottom: 20px;
            text-align: center;
            background: var(--accent-gradient);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .profile-cards-container {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
          }

          .profile-card {
            position: relative;
            width: 220px;
            height: 220px;
            background: var(--card-bg);
            padding: 20px;
            border-radius: 50%;
            box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1),
                        0 2px 4px -1px rgba(0,0,0,0.06);
            transition: 0.6s;
            margin: 20px;
          }
          .profile-card:hover {
            border-radius: 10px;
            height: 260px;
          }
          .profile-card .img {
            position: relative;
            width: 100%;
            height: 100%;
            transition: 0.6s;
            z-index: 99;
          }
          .profile-card:hover .img {
            opacity: 0;
          }
          .img img {
            width: 100%;
            border-radius: 50%;
            box-shadow: 0 0 22px #3336;
            transition: 0.6s;
            object-fit: cover;
          }
          .profile-card:hover img {
            border-radius: 10px;
          }
          .caption {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            opacity: 0;
            transition: opacity 0.6s;
            z-index: 100;
          }
          .profile-card:hover .caption {
            opacity: 1;
          }
          .caption h3 {
            margin: 10px;
            font-size: 1.3rem;
            color: var(--text-primary);
            margin-bottom: 0.1rem;
          }
          .caption p {
            justify-content: center;
            font-size: 0.95rem;
            margin: 10px;
            color: var(--text-secondary);
            margin-bottom: 0.5rem;
          }
          .caption .social-links a {
            justify-content: center;
            color: #fff;
            margin: 10px;
            font-size: 1.2rem;
            transition: 0.6s;
          }
          .social-links a:hover {
            transform: scale(1.1);
            justify-content: center;
            color: #8b5cf6;
          }

          @media (max-width: 768px) {
            .main {
              padding-top: 80px;
              padding-bottom: 40px;
            }
            .category-section h2 {
              font-size: 1.8rem;
            }
            .profile-card {
              margin: 20px auto;
            }
          }
          @media (max-width: 480px) {
            .profile-card {
              width: 180px;
              height: 180px;
              padding: 20px;
            }
            .profile-card:hover {
              height: 220px;
            }
            .caption h3 {
              font-size: 1.1rem;
            }
            .caption p {
              font-size: 0.9rem;
            }
          }
        `}</style>

        <div className="main" id="team">
          {/* Leadership (4 members) */}
          <div className="category-section">
            <h2>Leadership</h2>
            <div className="profile-cards-container">
              {/* Lohit */}
              <div className="profile-card">
                <div className="img">
                  <img src={lohitImg} alt="Lohitaksh Nandan" />
                </div>
                <div className="caption">
                  <h3>Lohitaksh Nandan</h3>
                  <p>CEO</p>
                  <div className="social-links">
                    <a
                      href="https://www.linkedin.com/in/lohitakshnandan/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                    <a
                      href="https://x.com/NandanLohitaksh"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-twitter"></i>
                    </a>
                  </div>
                </div>
              </div>
              {/* Kunal */}
              <div className="profile-card">
                <div className="img">
                  <img src={kunalImg} alt="Kunal Das" />
                </div>
                <div className="caption">
                  <h3>Kunal Das</h3>
                  <p>CTO</p>
                  <div className="social-links">
                    <a
                      href="https://www.linkedin.com/in/kunal-das-5qe23/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                    <a
                      href="https://x.com/kunal_da5"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a
                      href="https://kunaldas.vercel.app/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa-solid fa-globe"></i>
                    </a>
                  </div>
                </div>
              </div>
              {/* Isha */}
              <div className="profile-card">
                <div className="img">
                  <img src={ishaImg} alt="Isha Moharana" />
                </div>
                <div className="caption">
                  <h3>Isha Moharana</h3>
                  <p>CMO</p>
                  <div className="social-links">
                    <a
                      href="https://www.linkedin.com/in/isha-priya-moharana-32b175354/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </div>
                </div>
              </div>
              {/* Rasmiranjan */}
              <div className="profile-card">
                <div className="img">
                  <img src={rasmiranjanImg} alt="Rasmiranjan Ranasingh" />
                </div>
                <div className="caption">
                  <h3>Rasmiranjan Ranasingh</h3>
                  <p>CITO</p>
                  <div className="social-links">
                    <a
                      href="https://www.linkedin.com/in/rasmiranjan-ranasingh-a4a45312a/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tech Team (5 members) */}
          <div className="category-section">
            <h2>Tech Team</h2>
            <div className="profile-cards-container">
              {/* Dev 1: Samudra Saikia */}
              <div className="profile-card">
                <div className="img">
                  <img src={samudraImg} alt="Samudra Saikia" />
                </div>
                <div className="caption">
                  <h3>Samudra Saikia</h3>
                  <p>Senior Developer</p>
                  <div className="social-links">
                    <a
                      href="https://x.com/purp1exd"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/samudr4.io/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a
                      href="https://samudr4.github.io/purp1eweb/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa-solid fa-globe"></i>
                    </a>
                  </div>
                </div>
              </div>
              {/* Dev 2: Mehtab Aftabur Rosul */}
              <div className="profile-card">
                <div className="img">
                  <img src={mehtabImg} alt="Mehtab Aftabur Rosul" />
                </div>
                <div className="caption">
                  <h3>Mehtab A. Rosul</h3>
                  <p>
                    Director of R&D Department <br />
                    and AI-ML Engineer
                  </p>
                  <div className="social-links">
                    <a
                      href="https://www.linkedin.com/in/rosulmehtab/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                    <a
                      href="https://www.rosulmehtab.tech/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa-solid fa-globe"></i>
                    </a>
                    
                  </div>
                </div>
              </div>
              {/* Dev 3: Subhankar */}
              <div className="profile-card">
                <div className="img">
                  <img src={subhankar} alt="Subhankar" />
                </div>
                <div className="caption">
                  <h3>Subhankar Gharei</h3>
                  <p>Product Manager</p>
                  <div className="social-links">
                    <a href="/" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-facebook"></i>
                    </a>
                    <a href="/" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="/" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </div>
                </div>
              </div>
              {/* Dev 4: Prateek Singh */}
              <div className="profile-card">
                <div className="img">
                  <img src={prateek} alt="Prateek Singh" />
                </div>
                <div className="caption">
                  <h3>Prateek Singh</h3>
                  <p>MERN Developer</p>
                  <div className="social-links">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-facebook"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </div>
                </div>
              </div>
              {/* Dev 5: Varun Reddy */}
              <div className="profile-card">
                <div className="img">
                  <img src={varun} alt="Varun Reddy" />
                </div>
                <div className="caption">
                  <h3>Varun Reddy</h3>
                  <p>Python & Web3 Developer</p>
                  <div className="social-links">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-facebook"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Marketing & Sales (1 person) */}
          <div className="category-section">
            <h2>Marketing & Sales</h2>
            <div className="profile-cards-container">
              {/* Harshal Thale */}
              <div className="profile-card">
                <div className="img">
                  <img src={userImg} alt="Harshal Thale" />
                </div>
                <div className="caption">
                  <h3>Harshal Thale</h3>
                  <p>Director of Sales</p>
                  <div className="social-links">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-facebook"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Advisory Board (1 person) */}
          <div className="category-section">
            <h2>Advisory Board</h2>
            <div className="profile-cards-container">
              {/* Adyasha Rout */}
              <div className="profile-card">
                <div className="img">
                  <img src={adyashaImg} alt="Adyasha Rout" />
                </div>
                <div className="caption">
                  <h3>Adyasha Rout</h3>
                  <p>Business Advisor</p>
                  <div className="social-links">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-facebook"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Interns (3) */}
          <div className="category-section">
            <h2>Interns</h2>
            <div className="profile-cards-container">
              {/* Intern 1: Dhritishmita Kashyap */}
              <div className="profile-card">
                <div className="img">
                  <img src={dhriti} alt="Dhritishmita Kashyap" />
                </div>
                <div className="caption">
                  <h3>Dhritismita Kashyap</h3>
                  <p>Marketing Intern</p>
                  <div className="social-links">
                    <a
                      href="https://www.linkedin.com/in/dhritismitakashyap/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                    
                  </div>
                </div>
              </div>
              {/* Intern 2: Urbee Dutta */}
              <div className="profile-card">
                <div className="img">
                  <img src={userImg} alt="Urbee Dutta" />
                </div>
                <div className="caption">
                  <h3>Urbee Dutta</h3>
                  <p>MERN Developer</p>
                  <div className="social-links">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-facebook"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </div>
                </div>
              </div>
              {/* Intern 3: Akash Dutta */}
              <div className="profile-card">
                <div className="img">
                  <img src={akash} alt="Akash Dutta" />
                </div>
                <div className="caption">
                  <h3>Akash Dutta</h3>
                  <p>Flutter Developer</p>
                  <div className="social-links">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-facebook"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamPage;
